import Bar from "./Bar";

const Component = ({ component, dates, data }) => {
  let outage = 0;
  let nooutage = 0;

  return (
    <div>
      <div className="children-position" style={{ paddingRight: "11rem" }}>
        <div className="mt-6 flex flex-col space-y-4">
          <div className="bg-white dark:bg-slate-900 rounded-lg px-4 py-4 ring-1 ring-slate-900/5 shadow-sm border-2 border-t-black-500">
            <h1 className="text-slate-900 dark:text-white mt-5 text-base font-medium tracking-tight">
              {component?.name}
              <span style={{ float: "right" }}>{component?.data?.label}</span>
            </h1>
            <div style={{ display: "flex", alignItems: "left" }}>
              {dates?.map((date, index) => {
                const statusValues = [];
                const nameValues = [];
                let statusArray = [];
                let nameArray = [];
                let minutesArray = [];
                let hoursArray = [];
                let majorMinutes = [];
                let majorHours = [];
                let partialMinutes = [];
                let partialHours = [];

                const createdAtDate = component?.createdAt
                  ? component?.createdAt.split("T")[0]
                  : null;
                let status = "";
                let name = "";
                let hoursDifference = 0;
                let minutesDifference = 0;
                const found = data?.data?.data?.affectedComponents.find(
                  (incident) => {
                    if (incident.component === component.component) {
                      const statusFound = incident?.data.find((item) => {
                        const createdAtDate = item.createdAt
                          ? item.createdAt.split("T")[0]
                          : null;

                        const createAtDate = new Date(item.createdAt);
                        const updateAtDate = new Date(item.updatedAt);
                        const timeDiff = updateAtDate - createAtDate;

                        const minutesDiff = Math.floor(
                          (timeDiff % (1000 * 60 * 60)) / (1000 * 60)
                        );

                        const currentDate = new Date();
                        const previousDate = new Date() - 1;
                        const newDate = new Date(date);
                        const timeDifference = currentDate - createAtDate;

                        status = item?.updates?.label ? item.updates.label : "";
                        name = item?.incident?.name ? item.incident.name : "";

                        if (createdAtDate === date) {
                          // Check the created date and current date are same.
                          if (minutesDiff > 0) {
                            // If incident has closed it will calculated the time based on the looping date
                            hoursDifference = Math.floor(
                              timeDiff / (1000 * 60 * 60)
                            );
                            minutesDifference = Math.floor(
                              (timeDiff % (1000 * 60 * 60)) / (1000 * 60)
                            );
                          } else {
                            hoursDifference = Math.floor(
                              timeDifference / (1000 * 60 * 60)
                            );
                            minutesDifference = Math.floor(
                              (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
                            );
                          }
                          if (status === "Partial outage") {
                            statusValues.push(status);
                            nameValues.push(name);
                            partialMinutes.push(minutesDifference);
                            partialHours.push(hoursDifference);
                          } else if (status === "Major outage") {
                            statusValues.push(status);
                            nameValues.push(name);
                            majorMinutes.push(minutesDifference);
                            majorHours.push(hoursDifference);
                          }
                        } else if (createdAtDate < date) {
                          if (minutesDiff > 1) {
                            // If the incident is resolved
                            const updateAtDate1 = new Date(item.updatedAt);
                            const timeDiff1 = updateAtDate1 - newDate;
                            if (timeDiff1 > 0) {
                              hoursDifference = Math.floor(
                                timeDiff1 / (1000 * 60 * 60)
                              );
                              minutesDifference = Math.floor(
                                (timeDiff1 % (1000 * 60 * 60)) / (1000 * 60)
                              );
                            }
                          } else {
                            const timeDiff2 = currentDate - previousDate;
                            hoursDifference = Math.floor(
                              timeDiff2 / (1000 * 60 * 60)
                            );
                            minutesDifference = Math.floor(
                              (timeDiff2 % (1000 * 60 * 60)) / (1000 * 60)
                            );
                          }
                          if (status === "Partial outage") {
                            if (hoursDifference > 0 || minutesDifference > 0) {
                              statusValues.push(status);
                              nameValues.push(name);
                              partialMinutes.push(minutesDifference);
                              partialHours.push(hoursDifference);
                            }
                          } else if (status === "Major outage") {
                            if (hoursDifference > 0 || minutesDifference > 0) {
                              statusValues.push(status);
                              nameValues.push(name);
                              majorMinutes.push(minutesDifference);
                              majorHours.push(hoursDifference);
                            }
                          }
                        }
                      });
                      return statusFound;
                    }
                  }
                );

                const uniqueStatusValues = [...new Set(statusValues)];
                statusArray = uniqueStatusValues.join(", ");

                const uniqueNameValues = [...new Set(nameValues)];
                nameArray = uniqueNameValues.join(", ");

                const partialMinutesValues = partialMinutes.reduce(
                  (accumulator, currentValue) => accumulator + currentValue,
                  0
                );
                const partialHoursValues = partialHours.reduce(
                  (accumulator, currentValue) => accumulator + currentValue,
                  0
                );
                const majorMinutesValues = majorMinutes.reduce(
                  (accumulator, currentValue) => accumulator + currentValue,
                  0
                );
                const majorHoursValues = majorHours.reduce(
                  (accumulator, currentValue) => accumulator + currentValue,
                  0
                );

                let color = "green";
                if (
                  statusArray.includes("Partial outage") ||
                  statusArray.includes("Major outage")
                ) {
                  color = "red";
                  outage++;
                }
                if (statusArray) {
                  return (
                    <Bar
                      key={index}
                      date={date}
                      index={index}
                      color={color}
                      content={statusArray}
                      component={component?.component}
                      incident={nameArray}
                      majorHours={majorHoursValues}
                      majorMinutes={majorMinutesValues}
                      partialHours={partialHoursValues}
                      partialMinutes={partialMinutesValues}
                    />
                  );
                } else if (createdAtDate <= date) {
                  return (
                    <Bar
                      key={index}
                      date={date}
                      index={index}
                      color={color}
                      content={"No downtime recorded on this day."}
                      component={component?.component}
                      incident={""}
                    />
                  );
                } else {
                  return (
                    <Bar
                      key={index}
                      date={date}
                      index={index}
                      color="#b3bac5"
                      content="No data exists for this day."
                      component={component?.component}
                      incident={""}
                    />
                  );
                }
              })}
            </div>
            <p>
              90 Days ago
              <span>-------------------------------------------------</span>
              <span> {(100 - (90 / 100) * outage).toFixed(2)} % Uptime </span>
              <span>-------------------------------------------------</span>
              <span> Today</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Component;
